import {
  Box,
  Button,
  Divider,
  Flex,
  Grid,
  HStack,
  Link,
  Text,
} from "@chakra-ui/react";
import { IEmails, INumerosTelefone } from "../../../interfaces/GeneralSettings";

import IconAddress from "../../../assets/icons/contato-address.svg";
import IconEmail from "../../../assets/icons/contato-mail.svg";
import IconMessage from "../../../assets/icons/contato-message.svg";
import IconPhone from "../../../assets/icons/contato-phone.svg";
import NextLink from "next/link";
import React from "react";
import RichText from "../../RichText";
import TitleDefault from "../../TitleDefault";

interface Props {
  telefones: INumerosTelefone[];
  emails: IEmails[];
  endereco: string;
}

export default function InfoContato({ telefones, emails, endereco }: Props) {
  return (
    <>
      <TitleDefault titulo="Como podemos lhe ajudar" subtitulo="Contato" />
      <Text mb={10} mt="-3">
        Quer entrar em contato com a HERC? Então, confira nossos canais de
        comunicação e escolha o que melhor atende sua necessidade.
      </Text>
      <Grid
        templateColumns={[
          "repeat(1, 1fr)",
          "repeat(1, 1fr)",
          "repeat(1, 1fr)",
          "repeat(2, 1fr)",
        ]}
        gap={14}
        mb={10}
      >
        <Flex
          flexDir="column"
          boxShadow="lg"
          p={["50px 25px 25px"]}
          borderRadius="20px"
          bgGradient="linear( #EFEFF1 0, #EFEFF1 30px, #FFF 30px )"
        >
          <HStack mb={6}>
            <IconPhone />
            <Text color="#007DC5" textTransform="uppercase" fontWeight="medium">
              Números de contato
            </Text>
          </HStack>
          {telefones &&
            telefones.map((telefone) => (
              <HStack key={telefone.id} mb={2}>
                <Text color="#00377B" fontWeight="bold" fontSize="18px">
                  {telefone.nome}:
                  <Text
                    as="span"
                    color="#555"
                    fontSize="16px"
                    fontWeight="normal"
                    ml={2}
                  >
                    {telefone.numero}
                  </Text>
                </Text>
              </HStack>
            ))}
          <Divider mt={4} mb={6} />

          <HStack mb={4}>
            <IconAddress />
            <Text color="#007DC5" textTransform="uppercase" fontWeight="medium">
              Endereço
            </Text>
          </HStack>
          <Box fontSize="18px">
            <RichText text={endereco} />
          </Box>
        </Flex>

        <Flex
          flexDir="column"
          boxShadow="lg"
          p={["50px 25px 25px"]}
          borderRadius="20px"
          bgGradient="linear( #EFEFF1 0, #EFEFF1 30px, #FFF 30px )"
        >
          {emails &&
            emails.map((email, index) => (
              <Box key={email.id}>
                <HStack mb={6}>
                  <IconEmail />
                  <Text
                    color="#007DC5"
                    textTransform="uppercase"
                    fontWeight="medium"
                  >
                    {email.rotulo}
                  </Text>
                </HStack>

                <HStack key={email.id} mb={2}>
                  <Text color="#00377B" fontWeight="bold" fontSize="18px">
                    E-mail:
                    <NextLink href={`mailto:${email.email}`} passHref>
                      <Link
                        color="#555"
                        fontSize="16px"
                        fontWeight="normal"
                        ml={2}
                      >
                        {email.email}
                      </Link>
                    </NextLink>
                  </Text>
                </HStack>

                {emails.length !== index + 1 && <Divider mt={4} mb={6} />}
              </Box>
            ))}
        </Flex>
      </Grid>
    </>
  );
}
